import React from 'react';
import InterestsTags from './InterestsTags';
import styles from './interests-content.module.css';
import PropTypes from 'prop-types';

const InterestsContent = ({ field }) => {
    return (
        <section className={styles.interests}>
            <div className={styles.interests__item}>
                <InterestsTags>Business</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Community</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Donate</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Opportunity</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Donate</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Donate</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Opportunity</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Donate</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Donate</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Opportunity</InterestsTags>
            </div>
            <div className={styles.interests__item}>
                <InterestsTags>Donate</InterestsTags>
            </div>
        </section>
    );
};

InterestsContent.propTypes = {
    // children: PropTypes.node.isRequired
    field: PropTypes.string
};

export default InterestsContent;
